import './App.css';
import Header from './Header';
import SubHeader from './SubHeader';
import Home from './Home';
import Checkout from './Checkout';
import Login from './Login';
import Sign_in from './Sign_in';
import Payment from './Payment';
import Orders from './Orders';
import SearchResults from './SearchResults';
import ProductDetails from './ProductDetails';
import { BrowserRouter as Router, Routes, Route }
from "react-router-dom";
import React, { useEffect } from 'react';
import { db, auth } from './firebase';
import { useStateValue } from './StateProvider';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { collection, onSnapshot } from "firebase/firestore";


const promise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function App() {
  const [{ user }, dispatch] = useStateValue();

  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged(authUser => {
      if (authUser) {
        dispatch({ type: 'SET_USER', user: authUser });

        // --- NUOVA LOGICA: Sincronizzazione Carrello ---
        const cartRef = collection(db, "users", authUser.uid, "carrello");
        const unsubscribeCart = onSnapshot(cartRef, (snapshot) => {
          const dbBasket = snapshot.docs.map(doc => ({
            ...doc.data(),
            // Usiamo l'ID del documento se non c'è un originalID
            id: doc.id.split('_')[0] 
          }));
          
          dispatch({
            type: 'SET_BASKET_FROM_DB', // Aggiungeremo questo nel reducer
            basket: dbBasket
          });
        });

        return () => unsubscribeCart();
        // ----------------------------------------------

      } else {
        dispatch({ type: 'SET_USER', user: null });
        dispatch({ type: 'EMPTY_BASKET' }); // Svuota locale al logout
      }
    });

    return () => unsubscribeAuth();
  }, [dispatch]);

  return (
    <Router>
      <div className="app">

        <>
          <ToastContainer position="top-right" autoClose={1500} hideProgressBar />
        </>

        <Routes>
          <Route path="/checkout" element={
            <>
              <Header />
              <SubHeader />      
              <Checkout />
            </>
          } />

          <Route path="/payment" element={
            <>
              <Header />
              <SubHeader />
              <Elements stripe={promise}>      
                <Payment />
              </Elements>
            </>
          } />

          <Route path='/Sign_in' element={
            <>
              <Sign_in />
            </>
          } />

          <Route path="/login" element={
            <>      
              <Login />
            </>
          } />


          <Route path="/search" element={
            <>
              <Header />
              <SubHeader />
              <SearchResults />
            </>
          } />

          <Route path="/product/:id" element={
            <>
              <Header />
              <SubHeader />
              <ProductDetails />
            </>
          } />

          <Route path="/orders" element={
            <>
              <Header />
              <SubHeader />      
              <Orders />
            </>
          } />

          <Route path="/" element={
            <>
              <Header />
              <SubHeader />
              <Home />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;